// Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

import { Box, useTheme } from "@mui/material";
import { FreeMode, Navigation } from "swiper/modules";
import { Swiper, SwiperProps, SwiperSlide, SwiperSlideProps } from "swiper/react";

interface IHorizontalScroller extends SwiperProps {
  padding?: string;
}

const HorizontalScroller = ({ children, padding, ...props }: IHorizontalScroller) => {
  const theme = useTheme();
  return (
    <Box sx={{ "--swiper-navigation-color": theme.palette.dsNeutral.v400 }}>
      <Swiper
        direction="horizontal"
        slidesPerView="auto"
        slidesPerGroup={2}
        navigation
        freeMode={{
          enabled: true,
          sticky: false,
        }}
        modules={[FreeMode, Navigation]}
        style={{ paddingRight: padding || 0 }}
        {...props}
      >
        {children}
      </Swiper>
    </Box>
  );
};

interface IHorizontalScrollerItem extends SwiperSlideProps {
  margin?: string;
}

const HorizontalScrollerItem = ({ children, margin }: IHorizontalScrollerItem) => (
  <SwiperSlide style={{ width: "auto", marginLeft: margin || 0 }}>{children}</SwiperSlide>
);

export { HorizontalScroller, HorizontalScrollerItem };
